/**
 * Custom next/image loader: leitet Supabase-Storage-Bilder durch den
 * Supabase Render/Image-Transform-Endpoint (Resize + Kompression), statt sie
 * unverändert in Originalgröße auszuliefern. Läuft ohne Vercel Image-
 * Optimierung (kein Hobby-Plan-Limit) – Supabase übernimmt die Transformation.
 * Alle anderen Quellen (lokale Assets, Clerk, etc.) werden unverändert durchgereicht.
 */

const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL;
const OBJECT_PATH = '/storage/v1/object/public/';
const RENDER_PATH = '/storage/v1/render/image/public/';

interface LoaderParams {
  src: string;
  width: number;
  quality?: number;
}

export default function supabaseImageLoader({ src, width, quality }: LoaderParams): string {
  if (!SUPABASE_URL || !src.startsWith(`${SUPABASE_URL}${OBJECT_PATH}`)) {
    return src;
  }

  const [base, query] = src.replace(OBJECT_PATH, RENDER_PATH).split('?');
  const params = new URLSearchParams(query);
  params.set('width', String(width));
  params.set('quality', String(quality ?? 75));
  // Ohne height nie croppen (sonst croppt Supabase im Default-Modus "cover" quadratisch)
  params.set('resize', 'contain');

  return `${base}?${params.toString()}`;
}
